import React from "react";
import { Link } from "react-router-dom";
import { Image, Box, Stack } from "@chakra-ui/core";
import logo from "../../assets/dot-pay-logo.png";
import logoColored from "../../assets/dot-pay-logo-green.png";

const Logo = ({
  width = "120px",
  color = "brand",
  redirect = false,
  path = "/",
}) => {
  return (
    <Box>
      <Stack isInline>
        <Box>
          {redirect ? (
            <Link to={path}>
              <Image
                width={width}
                height="auto"
                src={color === "brand" ? logo : logoColored}
                className="App-logo"
                alt="dot-pay logo"
              />
            </Link>
          ) : (
            <Image
              width={width}
              height="auto"
              src={color === "brand" ? logo : logoColored}
              className="App-logo"
              alt="dot-pay logo"
            />
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default Logo;
